import type { KPI, Provenance } from '@losan/core';
import { pctOfTarget, yoyDelta } from '@losan/core';
import { DemoBadge } from './DemoBadge.js';

interface Props {
  label: string;
  kpi: KPI;
  format: 'eur' | 'int';
  provenance: Provenance;
}

const eurFmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const intFmt = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 });
const pctFmt = new Intl.NumberFormat('es-ES', { style: 'percent', maximumFractionDigits: 1, signDisplay: 'exceptZero' });

export function KpiCard({ label, kpi, format, provenance }: Props) {
  const fmt = format === 'eur' ? eurFmt : intFmt;
  const yoy = yoyDelta(kpi);
  const pct = pctOfTarget(kpi);
  const over = pct >= 1;
  return (
    <div className="kpi-card">
      <div className="label">
        {label}
        <DemoBadge provenance={provenance} />
      </div>
      <div className="value">{fmt.format(kpi.current)}</div>
      <div className="meta">
        <span className={`yoy ${yoy >= 0 ? 'up' : 'down'}`} title="Variación interanual">
          YoY {pctFmt.format(yoy)}
        </span>
        <span className="target" title="Porcentaje sobre objetivo">
          {Math.round(pct * 100)}% de {fmt.format(kpi.target)}
        </span>
      </div>
      <div className="progress" aria-label={`Progreso hacia objetivo: ${Math.round(pct * 100)}%`}>
        <div className={over ? 'over' : ''} style={{ width: `${Math.min(100, pct * 100)}%` }} />
      </div>
    </div>
  );
}
